export default "__VITE_ASSET__CaLpF8ln__"